module.exports = __webpack_public_path__ + "img/icon_empty.0c8e8aec.webp";